import { Box } from "@mui/material";

function DividerImage() {
    return (
        <Box
            component="img"
            src="/divider.jpg"
            alt="Divider"
            sx={{
                width: "40%",
                height: "auto",
                display: "center",
                mx: "auto",
                my: 4,
            }}
        />
    );
}

export default DividerImage;
